export default __webpack_public_path__ + "static/media/icon-localisation.188a2ac6.svg";